const API_BASE = import.meta.env.VITE_API_URL ?? '/v1'

export class ApiError extends Error {
  status: number
  code: string
  details?: unknown
  constructor(status: number, code: string, message: string, details?: unknown) {
    super(message)
    this.status = status
    this.code = code
    this.details = details
  }
}

function token(): string | null {
  return localStorage.getItem('discover.jwt')
}

export async function api<T = unknown>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers)
  headers.set('content-type', 'application/json')
  const t = token()
  if (t) headers.set('authorization', `Bearer ${t}`)

  const res = await fetch(`${API_BASE}${path}`, { ...init, headers })
  if (res.status === 204) return undefined as T

  let body: unknown
  try { body = await res.json() } catch { body = null }

  if (!res.ok) {
    const err = (body as { error?: { code: string; message: string; details?: unknown } })?.error
    throw new ApiError(res.status, err?.code ?? 'error', err?.message ?? `HTTP ${res.status}`, err?.details)
  }
  return body as T
}

export const apiClient = {
  get: <T>(path: string) => api<T>(path),
  post: <T>(path: string, body?: unknown) => api<T>(path, { method: 'POST', body: body ? JSON.stringify(body) : undefined }),
  patch: <T>(path: string, body?: unknown) => api<T>(path, { method: 'PATCH', body: body ? JSON.stringify(body) : undefined }),
  delete: <T>(path: string) => api<T>(path, { method: 'DELETE' }),
}
